import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-rerun-task',
  imports: [TranslateModule, MatButtonModule],
  templateUrl: './rerun-task.html',
  styleUrl: './rerun-task.scss',
})
export class RerunTask {
  @Input() message: string | undefined;
  @Output() rerun = new EventEmitter<void>();

  onRerunTask() {
    this.rerun.emit();
  }
}
